export default __webpack_public_path__ + "static/media/default-preview.a4331543.svg";